module.exports = __webpack_public_path__ + "img/charlie-reynolds.12119948.jpg";